<template>
    <RealtimeSystem
        :componentKey="componentKey"
        :onAnyEventsSocketScheme="onAnyEventsSocketScheme"
        @esparCalculated="onEsparCalculated"
    />
</template>

<script>
import RealtimeSystem from './RealtimeSystem.vue';
export default {
    name: 'RealtimeSystemEspar',
    components: {RealtimeSystem},
    data: () => ({
        componentKey: 'RealtimeSystemEspar',
        onAnyEventsSocketScheme: [
			{
				id: 'espar_calculated',
				eventNameSocket: 'espar_calculated',
				emitNameComponent: 'esparCalculated',
			},
		]
    }),
    methods: {
        onEsparCalculated(data) {
            this.$emit('esparCalculated', data);
        }
    }
}
</script>
